export default __webpack_public_path__ + "static/media/qr.9f632e49.png";